/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Messages_SyncingInputs */

const en_messages_syncing = /** @type {(inputs: Messages_SyncingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Syncing contacts from Google…`)
};

const he_messages_syncing = /** @type {(inputs: Messages_SyncingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מסנכרן אנשי קשר מגוגל…`)
};

/**
* | output |
* | --- |
* | "Syncing contacts from Google…" |
*
* @param {Messages_SyncingInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const messages_syncing = /** @type {((inputs?: Messages_SyncingInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_SyncingInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_syncing(inputs)
	return he_messages_syncing(inputs)
});